import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userSlice from "../feature/userSlice";
import inventorySlice from "../feature/inventorySlice";
import jobSlice from "../feature/jobSlice";
import permissionSlice from "../feature/permissionsSlice";
import roleSlice from "../feature/roleSlice";
import ContactSlice from "../feature/ContactSlice";
import tasksSlice from "../feature/tasksSlice";
import sequenceSlice from "../feature/sequenceSlice";
import billSlice from "../feature/shippinglistSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["userSlice", "ContactSlice"], // Add the desired reducers to persist
};

export const rootReducer = combineReducers({
    userSlice,
    inventorySlice,
    jobSlice,
    permissionSlice,
    tasksSlice,
    roleSlice,
    ContactSlice,
    sequenceSlice,
    billSlice,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
          getDefaultMiddleware({
                  serializableCheck: {
                            ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
                  },
          }),
});

export const persistor = persistStore(store);
